import { render, staticRenderFns } from "./ThemeMascot.vue?vue&type=template&id=21415d41&scoped=true&"
import script from "./ThemeMascot.vue?vue&type=script&lang=js&"
export * from "./ThemeMascot.vue?vue&type=script&lang=js&"
import style0 from "./ThemeMascot.vue?vue&type=style&index=0&id=21415d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21415d41",
  null
  
)

export default component.exports